export default  [{
    "id": 2,
    "name": "Aland Islands",
    "iso2": "AX"
},
{
    "id": 3,
    "name": "Albania",
    "iso2": "AL"
},
{
    "id": 4,
    "name": "Algeria",
    "iso2": "DZ"
},
{
    "id": 6,
    "name": "Andorra",
    "iso2": "AD"
},
{
    "id": 7,
    "name": "Angola",
    "iso2": "AO"
},
{
    "id": 8,
    "name": "Anguilla",
    "iso2": "AI"
},
{
    "id": 9,
    "name": "Antarctica",
    "iso2": "AQ"
},
{
    "id": 10,
    "name": "Antigua And Barbuda",
    "iso2": "AG"
},
{
    "id": 11,
    "name": "Argentina",
    "iso2": "AR"
},
{
    "id": 12,
    "name": "Armenia",
    "iso2": "AM"
},
{
    "id": 13,
    "name": "Aruba",
    "iso2": "AW"
},
{
    "id": 14,
    "name": "Australia",
    "iso2": "AU"
},
{
    "id": 16,
    "name": "Azerbaijan",
    "iso2": "AZ"
},
{
    "id": 17,
    "name": "The Bahamas",
    "iso2": "BS"
},
{
    "id": 18,
    "name": "Bahrain",
    "iso2": "BH"
},
{
    "id": 19,
    "name": "Bangladesh",
    "iso2": "BD"
},
{
    "id": 20,
    "name": "Barbados",
    "iso2": "BB"
},
{
    "id": 23,
    "name": "Belize",
    "iso2": "BZ"
},
{
    "id": 24,
    "name": "Benin",
    "iso2": "BJ"
},
{
    "id": 25,
    "name": "Bermuda",
    "iso2": "BM"
},
{
    "id": 26,
    "name": "Bhutan",
    "iso2": "BT"
},
{
    "id": 27,
    "name": "Bolivia",
    "iso2": "BO"
},
{
    "id": 250,
    "name": "Bonaire, Sint Eustatius, and Saba (BES islands) ",
    "iso2": "BQ"
},
{
    "id": 28,
    "name": "Bosnia and Herzegovina",
    "iso2": "BA"
},
{
    "id": 29,
    "name": "Botswana",
    "iso2": "BW"
},
{
    "id": 30,
    "name": "Bouvet Island",
    "iso2": "BV"
},
{
    "id": 31,
    "name": "Brazil",
    "iso2": "BR"
},
{
    "id": 32,
    "name": "British Indian Ocean Territory",
    "iso2": "IO"
},
{
    "id": 33,
    "name": "Brunei",
    "iso2": "BN"
},
{
    "id": 35,
    "name": "Burkina Faso",
    "iso2": "BF"
},
{
    "id": 37,
    "name": "Cambodia",
    "iso2": "KH"
},
{
    "id": 38,
    "name": "Cameroon",
    "iso2": "CM"
},
{
    "id": 39,
    "name": "Canada",
    "iso2": "CA"
},
{
    "id": 40,
    "name": "Cape Verde",
    "iso2": "CV"
},
{
    "id": 41,
    "name": "Cayman Islands",
    "iso2": "KY"
},
{
    "id": 42,
    "name": "Central African Republic",
    "iso2": "CF"
},
{
    "id": 43,
    "name": "Chad",
    "iso2": "TD"
},
{
    "id": 44,
    "name": "Chile",
    "iso2": "CL"
},
{
    "id": 45,
    "name": "China",
    "iso2": "CN"
},
{
    "id": 46,
    "name": "Christmas Island",
    "iso2": "CX"
},
{
    "id": 47,
    "name": "Cocos (Keeling) Islands",
    "iso2": "CC"
},
{
    "id": 48,
    "name": "Colombia",
    "iso2": "CO"
},
{
    "id": 49,
    "name": "Comoros",
    "iso2": "KM"
},
{
    "id": 52,
    "name": "Cook Islands",
    "iso2": "CK"
},
{
    "id": 53,
    "name": "Costa Rica",
    "iso2": "CR"
},
{
    "id": 54,
    "name": "Cote D'Ivoire (Ivory Coast)",
    "iso2": "CI"
},
{
    "id": 248,
    "name": "Curaçao",
    "iso2": "CW"
},
{
    "id": 60,
    "name": "Djibouti",
    "iso2": "DJ"
},
{
    "id": 61,
    "name": "Dominica",
    "iso2": "DM"
},
{
    "id": 62,
    "name": "Dominican Republic",
    "iso2": "DO"
},
{
    "id": 63,
    "name": "East Timor",
    "iso2": "TL"
},
{
    "id": 64,
    "name": "Ecuador",
    "iso2": "EC"
},
{
    "id": 65,
    "name": "Egypt",
    "iso2": "EG"
},
{
    "id": 66,
    "name": "El Salvador",
    "iso2": "SV"
},
{
    "id": 67,
    "name": "Equatorial Guinea",
    "iso2": "GQ"
},
{
    "id": 68,
    "name": "Eritrea",
    "iso2": "ER"
},
{
    "id": 70,
    "name": "Ethiopia",
    "iso2": "ET"
},
{
    "id": 71,
    "name": "Falkland Islands",
    "iso2": "FK"
},
{
    "id": 72,
    "name": "Faroe Islands",
    "iso2": "FO"
},
{
    "id": 73,
    "name": "Fiji Islands",
    "iso2": "FJ"
},
{
    "id": 76,
    "name": "French Guiana",
    "iso2": "GF"
},
{
    "id": 77,
    "name": "French Polynesia",
    "iso2": "PF"
},
{
    "id": 78,
    "name": "French Southern Territories",
    "iso2": "TF"
},
{
    "id": 79,
    "name": "Gabon",
    "iso2": "GA"
},
{
    "id": 80,
    "name": "Gambia The",
    "iso2": "GM"
},
{
    "id": 81,
    "name": "Georgia",
    "iso2": "GE"
},
{
    "id": 83,
    "name": "Ghana",
    "iso2": "GH"
},
{
    "id": 84,
    "name": "Gibraltar",
    "iso2": "GI"
},
{
    "id": 86,
    "name": "Greenland",
    "iso2": "GL"
},
{
    "id": 87,
    "name": "Grenada",
    "iso2": "GD"
},
{
    "id": 88,
    "name": "Guadeloupe",
    "iso2": "GP"
},
{
    "id": 90,
    "name": "Guatemala",
    "iso2": "GT"
},
{
    "id": 91,
    "name": "Guernsey and Alderney",
    "iso2": "GG"
},
{
    "id": 92,
    "name": "Guinea",
    "iso2": "GN"
},
{
    "id": 93,
    "name": "Guinea-Bissau",
    "iso2": "GW"
},
{
    "id": 94,
    "name": "Guyana",
    "iso2": "GY"
},
{
    "id": 95,
    "name": "Haiti",
    "iso2": "HT"
},
{
    "id": 96,
    "name": "Heard and McDonald Islands",
    "iso2": "HM"
},
{
    "id": 97,
    "name": "Honduras",
    "iso2": "HN"
},
{
    "id": 98,
    "name": "Hong Kong",
    "iso2": "HK"
},
{
    "id": 102,
    "name": "Indonesia",
    "iso2": "ID"
},
{
    "id": 106,
    "name": "Israel",
    "iso2": "IL"
},
{
    "id": 108,
    "name": "Jamaica",
    "iso2": "JM"
},
{
    "id": 110,
    "name": "Jersey",
    "iso2": "JE"
},
{
    "id": 111,
    "name": "Jordan",
    "iso2": "JO"
},
{
    "id": 112,
    "name": "Kazakhstan",
    "iso2": "KZ"
},
{
    "id": 113,
    "name": "Kenya",
    "iso2": "KE"
},
{
    "id": 114,
    "name": "Kiribati",
    "iso2": "KI"
},
{
    "id": 115,
    "name": "Kosovo",
    "iso2": "XK"
},
{
    "id": 116,
    "name": "Korea South",
    "iso2": "KR"
},
{
    "id": 117,
    "name": "Kuwait",
    "iso2": "KW"
},
{
    "id": 118,
    "name": "Kyrgyzstan",
    "iso2": "KG"
},
{
    "id": 119,
    "name": "Laos",
    "iso2": "LA"
},
{
    "id": 122,
    "name": "Lesotho",
    "iso2": "LS"
},
{
    "id": 123,
    "name": "Liberia",
    "iso2": "LR"
},
{
    "id": 128,
    "name": "Macau",
    "iso2": "MO"
},
{
    "id": 129,
    "name": "Macedonia",
    "iso2": "MK"
},
{
    "id": 130,
    "name": "Madagascar",
    "iso2": "MG"
},
{
    "id": 131,
    "name": "Malawi",
    "iso2": "MW"
},
{
    "id": 132,
    "name": "Malaysia",
    "iso2": "MY"
},
{
    "id": 133,
    "name": "Maldives",
    "iso2": "MV"
},
{
    "id": 136,
    "name": "Isle of Man",
    "iso2": "IM"
},
{
    "id": 137,
    "name": "Marshall Islands",
    "iso2": "MH"
},
{
    "id": 138,
    "name": "Martinique",
    "iso2": "MQ"
},
{
    "id": 139,
    "name": "Mauritania",
    "iso2": "MR"
},
{
    "id": 140,
    "name": "Mauritius",
    "iso2": "MU"
},
{
    "id": 141,
    "name": "Mayotte",
    "iso2": "YT"
},
{
    "id": 142,
    "name": "Mexico",
    "iso2": "MX"
},
{
    "id": 143,
    "name": "Micronesia",
    "iso2": "FM"
},
{
    "id": 144,
    "name": "Moldova",
    "iso2": "MD"
},
{
    "id": 145,
    "name": "Monaco",
    "iso2": "MC"
},
{
    "id": 146,
    "name": "Mongolia",
    "iso2": "MN"
},
{
    "id": 147,
    "name": "Montenegro",
    "iso2": "ME"
},
{
    "id": 148,
    "name": "Montserrat",
    "iso2": "MS"
},
{
    "id": 149,
    "name": "Morocco",
    "iso2": "MA"
},
{
    "id": 150,
    "name": "Mozambique",
    "iso2": "MZ"
},
{
    "id": 152,
    "name": "Namibia",
    "iso2": "NA"
},
{
    "id": 153,
    "name": "Nauru",
    "iso2": "NR"
},
{
    "id": 154,
    "name": "Nepal",
    "iso2": "NP"
},
{
    "id": 155,
    "name": "Netherlands Antilles",
    "iso2": "AN"
},
{
    "id": 157,
    "name": "New Caledonia",
    "iso2": "NC"
},
{
    "id": 160,
    "name": "Niger",
    "iso2": "NE"
},
{
    "id": 161,
    "name": "Nigeria",
    "iso2": "NG"
},
{
    "id": 162,
    "name": "Niue",
    "iso2": "NU"
},
{
    "id": 163,
    "name": "Norfolk Island",
    "iso2": "NF"
},
{
    "id": 166,
    "name": "Oman",
    "iso2": "OM"
},
{
    "id": 167,
    "name": "Pakistan",
    "iso2": "PK"
},
{
    "id": 168,
    "name": "Palau",
    "iso2": "PW"
},
{
    "id": 169,
    "name": "Palestinian Territory Occupied",
    "iso2": "PS"
},
{
    "id": 170,
    "name": "Panama",
    "iso2": "PA"
},
{
    "id": 171,
    "name": "Papua new Guinea",
    "iso2": "PG"
},
{
    "id": 172,
    "name": "Paraguay",
    "iso2": "PY"
},
{
    "id": 173,
    "name": "Peru",
    "iso2": "PE"
},
{
    "id": 174,
    "name": "Philippines",
    "iso2": "PH"
},
{
    "id": 175,
    "name": "Pitcairn Island",
    "iso2": "PN"
},
{
    "id": 179,
    "name": "Qatar",
    "iso2": "QA"
},
{
    "id": 180,
    "name": "Reunion",
    "iso2": "RE"
},
{
    "id": 182,
    "name": "Russia",
    "iso2": "RU"
},
{
    "id": 183,
    "name": "Rwanda",
    "iso2": "RW"
},
{
    "id": 184,
    "name": "Saint Helena",
    "iso2": "SH"
},
{
    "id": 185,
    "name": "Saint Kitts And Nevis",
    "iso2": "KN"
},
{
    "id": 186,
    "name": "Saint Lucia",
    "iso2": "LC"
},
{
    "id": 187,
    "name": "Saint Pierre and Miquelon",
    "iso2": "PM"
},
{
    "id": 188,
    "name": "Saint Vincent And The Grenadines",
    "iso2": "VC"
},
{
    "id": 189,
    "name": "Saint-Barthelemy",
    "iso2": "BL"
},
{
    "id": 190,
    "name": "Saint-Martin (French part)",
    "iso2": "MF"
},
{
    "id": 191,
    "name": "Samoa",
    "iso2": "WS"
},
{
    "id": 192,
    "name": "San Marino",
    "iso2": "SM"
},
{
    "id": 193,
    "name": "Sao Tome and Principe",
    "iso2": "ST"
},
{
    "id": 194,
    "name": "Saudi Arabia",
    "iso2": "SA"
},
{
    "id": 195,
    "name": "Senegal",
    "iso2": "SN"
},
{
    "id": 196,
    "name": "Serbia",
    "iso2": "RS"
},
{
    "id": 197,
    "name": "Seychelles",
    "iso2": "SC"
},
{
    "id": 198,
    "name": "Sierra Leone",
    "iso2": "SL"
},
{
    "id": 199,
    "name": "Singapore",
    "iso2": "SG"
},
{
    "id": 249,
    "name": "Sint Maarten",
    "iso2": "SX"
},
{
    "id": 202,
    "name": "Solomon Islands",
    "iso2": "SB"
},
{
    "id": 204,
    "name": "South Africa",
    "iso2": "ZA"
},
{
    "id": 205,
    "name": "South Georgia",
    "iso2": "GS"
},
{
    "id": 210,
    "name": "Suriname",
    "iso2": "SR"
},
{
    "id": 211,
    "name": "Svalbard And Jan Mayen Islands",
    "iso2": "SJ"
},
{
    "id": 212,
    "name": "Swaziland",
    "iso2": "SZ"
},
{
    "id": 216,
    "name": "Taiwan",
    "iso2": "TW"
},
{
    "id": 217,
    "name": "Tajikistan",
    "iso2": "TJ"
},
{
    "id": 218,
    "name": "Tanzania",
    "iso2": "TZ"
},
{
    "id": 219,
    "name": "Thailand",
    "iso2": "TH"
},
{
    "id": 220,
    "name": "Togo",
    "iso2": "TG"
},
{
    "id": 221,
    "name": "Tokelau",
    "iso2": "TK"
},
{
    "id": 222,
    "name": "Tonga",
    "iso2": "TO"
},
{
    "id": 223,
    "name": "Trinidad And Tobago",
    "iso2": "TT"
},
{
    "id": 224,
    "name": "Tunisia",
    "iso2": "TN"
},
{
    "id": 225,
    "name": "Turkey",
    "iso2": "TR"
},
{
    "id": 226,
    "name": "Turkmenistan",
    "iso2": "TM"
},
{
    "id": 227,
    "name": "Turks And Caicos Islands",
    "iso2": "TC"
},
{
    "id": 228,
    "name": "Tuvalu",
    "iso2": "TV"
},
{
    "id": 229,
    "name": "Uganda",
    "iso2": "UG"
},
{
    "id": 230,
    "name": "Ukraine",
    "iso2": "UA"
},
{
    "id": 231,
    "name": "United Arab Emirates",
    "iso2": "AE"
},
{
    "id": 235,
    "name": "Uruguay",
    "iso2": "UY"
},
{
    "id": 236,
    "name": "Uzbekistan",
    "iso2": "UZ"
},
{
    "id": 237,
    "name": "Vanuatu",
    "iso2": "VU"
},
{
    "id": 238,
    "name": "Vatican City State (Holy See)",
    "iso2": "VA"
},
{
    "id": 240,
    "name": "Vietnam",
    "iso2": "VN"
},
{
    "id": 241,
    "name": "Virgin Islands (British)",
    "iso2": "VG"
},
{
    "id": 243,
    "name": "Wallis And Futuna Islands",
    "iso2": "WF"
},
{
    "id": 244,
    "name": "Western Sahara",
    "iso2": "EH"
},
{
    "id": 246,
    "name": "Zambia",
    "iso2": "ZM"
},
{
    "id": 247,
    "name": "Zimbabwe",
    "iso2": "ZW"
}
]


// WEBPACK FOOTER //
// ./src/store/country_list.js